import apiClient from './client';

export async function initAuth() {
  const role = localStorage.getItem('userRole');

  if (!role) {
    return null;
  }

  try {
    const refreshRes = await apiClient.post('/auth/refresh');
    const newAccessToken = refreshRes.data?.accessToken;

    if (!newAccessToken) {
      throw new Error('Не получен access token');
    }

    localStorage.setItem('accessToken', newAccessToken);

    if (role === 'EXECUTOR') {
      const profileRes = await apiClient.get('/executors/me/profile');
      return {
        role,
        profile: profileRes.data,
      };
    }

    if (role === 'CUSTOMER') {
      const profileRes = await apiClient.get('/customers/me/profile');
      return {
        role,
        profile: profileRes.data,
      };
    }

    return null;
  } catch (error) {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userRole');
    return null;
  }
}